let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bI3DO"), load("88r9N")]).then(() => parcelRequire('lwRK9'));